export const MEMBER_CLASSES_ACTION_TYPES = {
    SET_CLASSES: "SET_CLASSES"
};